import { cn } from "@/lib/utils";
import type { ProductStatus } from "@/types/models";

const statusConfig: Record<
  ProductStatus,
  { label: string; className: string }
> = {
  DRAFT: {
    label: "Rascunho",
    className: "border-primary-300 dark:border-primary-700 text-primary-600 dark:text-primary-400",
  },
  ACTIVE: {
    label: "Ativo",
    className: "border-green-600 text-green-700 dark:text-green-400",
  },
  ARCHIVED: {
    label: "Arquivado",
    className: "border-primary-400 dark:border-primary-600 text-primary-500 dark:text-primary-500",
  },
};

export interface ProductStatusBadgeProps {
  status: ProductStatus;
}

export function ProductStatusBadge({ status }: ProductStatusBadgeProps) {
  const config = statusConfig[status];

  return (
    <span
      className={cn(
        "inline-block px-2 py-0.5 text-xs uppercase tracking-widest border",
        config.className
      )}
    >
      {config.label}
    </span>
  );
}
